<template>
  <div>
    <page-header :header="$t('company.your_prices')" />

    <div class="content">
      <PricingAlert></PricingAlert>
      <b-row>
        <b-col lg="4">
          <b-card>
            <div v-if="$allows('administer')">
              <field
                :field="fields.byAttribute.company_id"
                layout="vertical"
                @input="onCompanyChange"
              ></field>
            </div>

            <field
              :field="fields.byAttribute.division_id"
              layout="vertical"
              @input="onDivisionChange"
            ></field>

            <field
              :field="fields.byAttribute.vehicle_id"
              layout="vertical"
            ></field>
          </b-card>

          <b-card
            v-if="dataLoaded"
            :title="$t('vehicles.field_groups.standard')"
          >
            <fields group="standard" />
          </b-card>

          <b-card
            v-if="dataLoaded"
            :title="$t('vehicles.field_groups.additional')"
          >
            <fields group="additional" />
          </b-card>

        </b-col>
        <b-col v-if="dataLoaded" lg="4">
          <b-card>
            <field name="pricing.per_minute"></field>
          </b-card>

          <b-card :title="$t('vehicles.attributes.pricing.price_per_km.label')">
            <fields group="price_per_km" />
          </b-card>
          <b-card
            :title="$t('vehicles.attributes.pricing.return_price_per_km.label')"
          >
            <fields group="return_price_per_km" />
          </b-card>
        </b-col>
        <b-col lg="8">
          <b-card v-if="dataLoaded" class="text-right">
            <div class="bottom-button-cover">
              <div class="form-check text-left any-division">
                <input
                  id="any_division"
                  v-model="any_division"
                  :false-value="0"
                  :true-value="1"
                  type="checkbox"
                  class="form-check-input"
                />
                <label for="any_division">
                  {{ $t('company.any_division') }}
                </label>
              </div>
              <div v-if="$allows('administer')">
                <b-button variant="btn btn-danger btn-lg" size="lg" @click="deletePrice"
                >{{ $t('general.delete') }}
                </b-button>
                <b-button v-if="model.active === 0" variant="btn btn-success btn-lg" size="lg" @click="approve"
                >{{ $t('general.approve') }}
                </b-button>
                <b-button v-if="model.active === 1" variant="btn btn-warning btn-lg" size="lg" @click="refuse"
                >{{ $t('general.refuse') }}
                </b-button>
              </div>
              <b-button variant="primary" size="lg" @click="save">{{
                  $t('general.save')
                }}</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ResourceFormMixin from '../stylemix-vue-admin/mixins/ResourceFormMixin'
import Api from './Api'
import PricingAlert from './PricingAlert.vue'
import { applyAverages, applyAveragesPerKm, weekDays } from './utils'
import { mapState } from 'vuex'

export default {
  name: 'CityTaxiPricing',

  components: {
    PricingAlert,
  },

  mixins: [ResourceFormMixin],

  data() {
    return {
      formLoaded: false,
      dataLoaded: false,
      has_pricing: null,
      any_division: 1,
      active: null,
    }
  },

  computed: {
    ...mapState('zones', ['currentDivision']),
    days: () => weekDays,

    selectedCurrency() {
      return this.$root.$account.currency ?? this.$settings.base_currency
    },
  },

  watch: {
    selectedCurrency() {
      this.loadPrices()
    },
    'model.company_id': function () {
      this.resetPricesData()
      this.loadDivisions()
    },
    'model.division_id': function () {
      this.loadVehicles()
    },
    'model.vehicle_id': function () {
      this.loadPrices()
    },
    currentDivision() {
      this.updateCompanyFilters()
    },
    has_pricing() {
      this.updateCompanyFilters()
    },
    any_division: {
      handler(newVal, oldVal) {
        this.model.any_division = newVal;
      }
    },
    formLoaded(val) {
      if (val) {
        this.loadPrices()
      }
    },
    'model.pricing.one_way': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return, oldVal))
          this.model.pricing.return = this.model.pricing.one_way;
      }
    },
    'model.pricing.price_per_km.0.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[0].price, oldVal))
          this.model.pricing.return_price_per_km[0].price = this.model.pricing.price_per_km[0].price;
      }
    },
    'model.pricing.price_per_km.1.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[1].price, oldVal))
          this.model.pricing.return_price_per_km[1].price = this.model.pricing.price_per_km[1].price;
      }
    },
    'model.pricing.price_per_km.2.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[2].price, oldVal))
          this.model.pricing.return_price_per_km[2].price = this.model.pricing.price_per_km[2].price;
      }
    },
    'model.pricing.price_per_km.3.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[3].price, oldVal))
          this.model.pricing.return_price_per_km[3].price = this.model.pricing.price_per_km[3].price;
      }
    },
    'model.pricing.price_per_km.4.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[4].price, oldVal))
          this.model.pricing.return_price_per_km[4].price = this.model.pricing.price_per_km[4].price;
      }
    },
    'model.pricing.price_per_km.5.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[5].price, oldVal))
          this.model.pricing.return_price_per_km[5].price = this.model.pricing.price_per_km[5].price;
      }
    },
    'model.pricing.price_per_km.6.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[6].price, oldVal))
          this.model.pricing.return_price_per_km[6].price = this.model.pricing.price_per_km[6].price;
      }
    },
    'model.pricing.price_per_km.7.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[7].price, oldVal))
          this.model.pricing.return_price_per_km[7].price = this.model.pricing.price_per_km[7].price;
      }
    },
    'model.pricing.price_per_km.8.price': {
      handler(newVal, oldVal) {
        if (this.checkFieldValue(this.model.pricing?.return_price_per_km[8].price, oldVal))
          this.model.pricing.return_price_per_km[8].price = this.model.pricing.price_per_km[8].price;
      }
    },
  },

  created() {
    this.loadForm().then(() => {
      this.model = { ...this.model, ...this.$route.params }

      this.updateReturnPrices();
    })
  },

  methods: {
    api() {
      return new Api()
    },

    resetPricesData() {
      this.model.pricing = null
      this.dataLoaded = false
    },

    loadForm() {
      return this.api()
        .getCityTaxiPricingForm({
          company_id: this.$route.params.company_id,
        })
        .then((response) => {
          this.setFields(response.fields)

          this.setFieldGroup('standard', [
            'pricing.one_way',
            'pricing.return',
            'pricing.return_discount',
            'pricing.standing_fee',
            'pricing.minimum_price',
            'pricing.stopway_minimum',
          ])
          this.setFieldGroup('additional', [
            'pricing.meet_greet',
            'pricing.disabled_place',
            'pricing.baby_seat',
            'pricing.booster_seat',
            'pricing.child_seat',
            'pricing.bike',
            'pricing.ski_equipment_fee',
            'pricing.passenger_fee_min',
            'pricing.passenger_fee',
            'pricing.animal_fee',
            'pricing.waiting_time_per_minute',
          ])
          this.setFieldGroup('day_night', [
            'pricing.night_threshold.start',
            'pricing.night_threshold.end',
            'pricing.days_metric',
          ])

          this.updateCompanyFilters()

          this.formLoaded = true
        })
    },

    loadPrices() {
      if (!this.formLoaded) {
        return
      }

      this.resetPricesData()

      if (this.$allows('administer') && !this.model.company_id) {
        return
      }

      if (!this.model.vehicle_id || !this.model.division_id) {
        return
      }

      this.api()
        .getCityTaxiPricing({
          company_id: this.model.company_id,
          division_id: this.model.division_id,
          vehicle_id: this.model.vehicle_id,
        })
        .then(({ averages, pricing, currency_label, active }) => {
          this.model = { ...this.model, pricing, active }

          applyAveragesPerKm(this.fields, averages, this.selectedCurrency, (value) =>
            this.$options.filters.currency(value, this.selectedCurrency.symbol)
          )
          applyAverages(this.fields, averages, pricing, this.selectedCurrency, (value) =>
            this.$options.filters.currency(value, this.selectedCurrency.symbol)
          )

          this.dataLoaded = true
        })
    },

    loadDivisions() {
      if (
        !this.formLoaded ||
        (this.$allows('administer') && this.model.company_id === null)
      ) {
        return
      }

      this.fields.byAttribute.division_id.options = []

      new Api()
        .getDivisions({
          context: 'pricingOptions',
          where: {
            company_id: this.model.company_id,
            division_id: this.currentDivision.id,
            ride_type: 'transfer',
          },
        })
        .then(({ data }) => {
          this.fields.byAttribute.division_id.options = data
        })
    },

    loadVehicles() {
      if (!this.formLoaded || !this.model.division_id) {
        return
      }

      this.fields.byAttribute.vehicle_id.options = []
      new Api()
        .getVehicles({
          context: 'pricingOptions',
          where: {
            company_id: this.model.company_id,
            division_id: this.model.division_id,
            ride_type: 'transfer',
          },
        })
        .then(({ data }) => {
          this.fields.byAttribute.vehicle_id.options = data
        })
    },

    save() {
      this.errors.clear()
      this.model.any_division = this.any_division;

      const promise = this.api()
        .updateCityTaxiPricing(this.model)
        .then((result) => {
          this.$toast.success(result.message)
          return result
        })
        .catch((response) => {
          this.onSaveError(response)
          return Promise.reject(response)
        })

      return this.$uiBlocker(promise, this.$el)
    },

    approve() {
      const promise = this.api()
        .approveCityTaxiPricing(this.model)
        .then((result) => {
          this.model.active = 1
          this.$toast.success(result.message)
          return result
        })
        .catch((response) => {
          this.onSaveError(response)
          return Promise.reject(response)
        })

      return this.$uiBlocker(promise, this.$el)
    },

    refuse() {
      const promise = this.api()
        .refuseCityTaxiPricing(this.model)
        .then((result) => {
          this.model.active = 0
          this.$toast.success(result.message)
          return result
        })
        .catch((response) => {
          this.onSaveError(response)
          return Promise.reject(response)
        })

      return this.$uiBlocker(promise, this.$el)
    },

    async deletePrice() {
      const answer = !!(await this.$alert.question(
        this.$t('companies.messages.confirm_deleting'),
      )).value
      if (answer === false) {
        return
      }
      this.api()
        .deleteCityTaxiPricing(this.model)
        .then((result) => {
          this.$toast.success(result.message)
        })
      await this.$router.push({name: `${'company-pricings.city-taxi.index'}`})
    },

    updateCompanyFilters() {
      if (this.fields.byAttribute['company_id']) {
        this.fields.byAttribute['company_id'].source.params = {
          ...this.fields.byAttribute['company_id'].source.params,
          filter: {
            division_id: this.currentDivision.id,
            has_division_pricing: this.has_pricing,
          },
        }
      }
    },


    onDivisionChange() {
      this.model.vehicle_id = null
    },

    onCompanyChange() {
      this.model.division_id = null
      this.model.vehicle_id = null
    },

    checkFieldValue(field, oldVal) {
      return field !== 0 && (field === null || field === '' || field === oldVal);
    },

    updateReturnPrices() {
      if (this.checkFieldValue(this.model.pricing?.return, null))
        this.model.pricing.return = this.model.pricing.one_way;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[0].price, null))
        this.model.pricing.return_price_per_km[0].price = this.model.pricing.price_per_km[0].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[1].price, null))
        this.model.pricing.return_price_per_km[1].price = this.model.pricing.price_per_km[1].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[2].price, null))
        this.model.pricing.return_price_per_km[2].price = this.model.pricing.price_per_km[2].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[3].price, null))
        this.model.pricing.return_price_per_km[3].price = this.model.pricing.price_per_km[3].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[4].price, null))
        this.model.pricing.return_price_per_km[4].price = this.model.pricing.price_per_km[4].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[5].price, null))
        this.model.pricing.return_price_per_km[5].price = this.model.pricing.price_per_km[5].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[6].price, null))
        this.model.pricing.return_price_per_km[6].price = this.model.pricing.price_per_km[6].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[7].price, null))
        this.model.pricing.return_price_per_km[7].price = this.model.pricing.price_per_km[7].price;

      if (this.checkFieldValue(this.model.pricing?.return_price_per_km[8].price, null))
        this.model.pricing.return_price_per_km[8].price = this.model.pricing.price_per_km[8].price;
    },
  },
}
</script>
<style>
.bottom-button-cover {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.form-check.text-left.any-division {
  margin: 10px 25px 0 0;
}
.bottom-button-cover button.btn {
  margin: 3px;
}
</style>
